/* eslint-disable no-console */

import { register } from 'register-service-worker'
import {version} from '../package'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready () {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered () {
            console.log('Service worker has been registered.')
        },
        cached () {
            console.log('Content has been cached for offline use.')
        },
        updatefound () {
            console.log('New content is downloading.')
        },
        updated (registration) {
            console.log('New content is available; please refresh.');
            document.dispatchEvent(
                new CustomEvent('swUpdated', {detail: registration})
            );
            /*
                        if(!window.navigator && !window.navigator.serviceWorker && !window.navigator.serviceWorker.controller){
                            return
                        }
            */
            // if(!window.navigator && !window.navigator.serviceWorker){
            //     return
            // }
            // var elem = document.createElement('div');
            // var cont = document.createElement('div');
            // var text = document.createElement('div');
            // var button = document.createElement('input');
            //
            // elem.style.cssText = 'position:absolute;left:0;top:0;background-color:rgba(36, 38, 41, 0.7);margin:0px;font-weight:700;box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);min-width:320px;font-family:monospace;color:white;cursor:pointer;z-index:99999;text-align:center;width: 100%; min-height:100%;';
            // // elem.style.cssText = 'position:fixed;bottom:0;right:0;background-color:rgba(36, 38, 41, 0.9);margin:10px;border-radius:.5rem;font-weight:700;box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);min-width:320px;font-family:monospace;color:white;cursor:pointer;z-index:99999;text-align:center;width: -webkit-fill-available;';
            //
            // cont.style.cssText='height:auto;position:relative;top:265px; margin:0 auto;';
            // text.innerHTML = "יש גרסה חדשה";
            // text.style.cssText = 'padding-top:10px;padding-bottom:55px;font-family: arial;font-size:22px';
            //
            // // button.innerHTML = 'לחץ לעדכן גרסה';
            // button.setAttribute("type", "button");
            // button.setAttribute("value", "לחץ לעדכן גרסה")
            // button.style.cssText = 'padding:10px;background-color:#0288d1;border:0;border-radius:8px;font-family: arial;font-size:20px';
            //
            // document.body.appendChild(elem);
            // elem.appendChild(cont);
            // cont.appendChild(text);
            // cont.appendChild(button);
            // button.addEventListener('click', function () {
            //     console.log("Update Clicke");
            //     // navigator.serviceWorker.postMessage('updateApp');
            //     console.log(window.location);
            //     let hostname = window.location.hostname;
            //     let urlPrefix = "localhost";
            //     if(hostname){
            //         let sp = hostname.split('/.');
            //         urlPrefix = sp[0];
            //     }
            //
            //     // navigator.serviceWorker.controller.postMessage({action: 'updateApp', urlPrefix:urlPrefix} )
            //     navigator.serviceWorker.getRegistrations()
            //         .then(function(registrations) {
            //             for(let registration of registrations) {
            //                 registration.unregister();
            //             }
            //         }).then(()=>{
            //
            //         caches.keys().then((keys) => {
            //             console.log(keys);
            //             return Promise.all(
            //                 keys.map(cacheName => {
            //                     // Delete the caches that are not the current one.
            //                     // let urlPrefix = event.data.urlPrefix;
            //                     if(!cacheName.includes("ayalon-pwa-c") && !cacheName.includes(urlPrefix)){
            //                         return;
            //                     }
            //                     return caches.delete(cacheName)
            //                 })
            //             )
            //         })
            //     }).then(() => {
            //         window.location.reload();
            //     })
            //
            // })

        },
        offline () {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error (error) {
            console.error('Error during service worker registration:', error)
        }
    })
    /*
        let refreshing;
        navigator.serviceWorker.addEventListener('controllerchange',
            function() {
                if (refreshing) return;
                refreshing = true;
                window.location.reload();
            }
        );
    */
}
